import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({ selector: '[vpViewHost]' })
export class ViewHostDirective {
    public viewContainerRef = inject(ViewContainerRef);
}
